import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DataTable, { SortOrder } from "react-data-table-component";
import { withTranslation } from "react-i18next";
import { useHistory, useLocation, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Form, Input } from "reactstrap";
import { DefaultThemeForReactTable, Loader } from "src/components";
import { ApproveRegistrationUser, getPaginationRequestInitialValue, PaginationRequest, Users } from "src/sdk";
import { Organisation } from "src/sdk/models/Organisation";
import { SuperAdminService } from "src/services/SuperAdminService";
import Swal from 'sweetalert2';
import { UsersManagmentColumns } from "./UsersManagmentColumns";

const service = new SuperAdminService();
export const UsersManagment = () => {
    const history = useHistory();
    const location = useLocation();

    const [usersData, setUsersData] = useState<Users[]>([]);
    const [loading, setLoading] = useState(false);
    const [paginationResetDefaultPage, setPaginationResetDefaultPage] = useState(false);
    const [totalRows, setTotalRows] = useState(10000);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>("");
    const [sortOrder, setSortOrder] = useState<string>("");

    /////////////////////////////search
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            search: ""
        },
        onSubmit: (values: any) => {
            fetchPage(page, values.search, true, sortBy, sortOrder);
            setSearch(values.search);
        }
    });

    ////////////////////////Pagination
    const fetchPage = async (page: any, search: any, paginationResetDefaultPage: any, sortBy: any, sortOrder: any) => {
        setLoading(true);

        let pagination: PaginationRequest = getPaginationRequestInitialValue();
        pagination.page = page;
        pagination.pageSize = perPage;
        pagination.search = search;
        pagination.sortBy = sortBy;
        pagination.sortOrder = sortOrder;
        pagination.organisationId = location ? location.state.id : 0;
        console.log(location)

        getUsersByOrganisationId(setUsersData, pagination, setTotalRows, setLoading);
        setPaginationResetDefaultPage(paginationResetDefaultPage);
    };

    useEffect(() => {
        fetchPage(page, "", false, sortBy, sortOrder); // fetch page 1 of users
    }, []);

    const handlePageChange = (pageNew: any) => {
        fetchPage(pageNew, search, false, sortBy, sortOrder);
    };

    const handlePerRowsChange = async (newPerPage: any, page: any) => {
        setLoading(true);
        let pagination: PaginationRequest = getPaginationRequestInitialValue();
        pagination.page = page;
        pagination.pageSize = newPerPage;
        pagination.search = search;
        pagination.sortBy = sortBy;
        pagination.sortOrder = sortOrder;

        getUsersByOrganisationId(setUsersData, pagination, setTotalRows, setLoading);
        setPerPage(newPerPage);
    };

    const sortPagination = (state: any, sortDirection: SortOrder) => {
        setSortOrder(sortDirection);
        setSortBy(state.id);
        fetchPage(page, search, false, state.id, sortDirection); // fetch page 1 of users
    }

    /////////////////////// Style Pagination
    const paginationComponentOptions = {
        rowsPerPageText: "Rows per page",
        rangeSeparatorText: "of",
        selectAllRowsItem: false,
    };

    ///////////////////////////////////////////////////////////////////
    const onEditUser = (values: Users) => {
        console.log(values)
        history.push({
            pathname: '/edit-usersManagment',
            state: { users: values as Users, organisation: location.state }
        })
    }

    const onDeleteUser = (userId: string) => {
        console.log(userId);
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire(
                    'Deleted!',
                    'Your user has been deleted.',
                    'success'
                )
                service.deleteUser(userId)
                    .then(function (response) {
                        console.log(response);
                        setUsersData([
                            ...usersData.filter((element) => {
                                return element.userId !== userId
                            }),
                        ]);
                    })
                    .catch(function (error) {
                        console.log("API ERROR");
                        console.log(error);
                    });
            }
        })
    }

    const isApprovedRegistrationUser = (userId: string) => {
        let approve: ApproveRegistrationUser = {
            userId: userId,
            isApproved: true,
        }

        service.approveRegistrationUser(approve)
            .then(function (response) {
                console.log("API IS APPROVED");
                console.log(response);
                fetchPage(page, search, false, sortBy, sortOrder);
            })
            .catch(function (error) {
                console.log("API ERROR");
                console.log(error);
            });
    }

     const assignedUserRole = (values: Users, check: boolean) => {
              let asignUserRole: Users = {
                 userId: values.userId,            
                 isAdmin: check
             } 
            console.log(asignUserRole)
            service.asignUserRole(asignUserRole)
                .then(function (response) {
                    console.log("ASIGNED USER");
                    console.log(response);
                    fetchPage(1, "", false, sortBy, sortOrder);
                })
                .catch(function (error) {
                    console.log("API ERROR");
                    console.log(error);
                }); 
        }
    return (
        <React.Fragment>
            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
                            <Link style={{ color: "black" }}
                                to="/organisations"
                                className="nav_link"
                            >
                                <h5>Organizations</h5>
                            </Link>
                            <i className="bi bi-chevron-right"></i>
                            <h5 style={{ marginRight: 13, marginLeft: 13 }}>{location.state.name}</h5>
                            <i className="bi bi-chevron-right"></i>
                            <h5 style={{ marginLeft: 13, opacity: 0.6 }}>Users List</h5>
                        </div>
                    </div>
                </div>
                {/* ////////////////////////////////////////////////////// */}
                <div className="d-flex mb-3">
                    <div className="me-auto w-50">
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                            }}
                        >
                            <div className="form-group m-0">
                                <div className="input-group">
                                    <Input
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by email ..."
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.search || ""}
                                    />
                                    <div className="input-group-append">
                                        <button
                                            className="btn btn-secondary rounded-0 rounded-end bi bi-search"
                                            type="submit"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                    {/* ////////////////////////////////////////////////// */}
                    <div>
                        <Link
                            className="btn btn-secondary btn-block"
                            to={{
                                pathname: '/create-user',
                                state: {organisation: location.state }
                            }}
                        >
                            Add user
                        </Link>
                    </div>
                </div>
                <div className="table-responsive pb-5 mb-5 w-100">
                    <DataTable
                        data={usersData}
                        columns={UsersManagmentColumns(onEditUser, onDeleteUser, isApprovedRegistrationUser, assignedUserRole)}
                        customStyles={DefaultThemeForReactTable()}
                        progressPending={loading}
                        progressComponent={<Loader loading={loading} />}
                        ///////////////Pagination
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationResetDefaultPage={paginationResetDefaultPage}
                        onChangeRowsPerPage={handlePerRowsChange}
                        pointerOnHover={true}
                        onChangePage={handlePageChange}
                        paginationComponentOptions={paginationComponentOptions}
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                        onSort={sortPagination}
                        defaultSortAsc={false}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}
UsersManagment.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withTranslation()(withRouter(UsersManagment));

////////Get all users
export const getUsersByOrganisationId = (setUsersData: any, pagination: any, setTotalRows: any, setLoading: any) => {
    service.getUsersByOrganisationId(pagination)
        .then(function (response) {
            console.log("API GET USERS");
            console.log(response);
            setTotalRows(response.data.totalRecords);
            setUsersData(response.data);
            setLoading(false);
        })
        .catch(function (error) {
            console.log("API ERROR");
            console.log(error);
        })
}  